import React, { useEffect, useRef, useState } from 'react';
import { Spin, Tag } from 'antd';
import { getData } from '@util';
import { API_POST_RECOGNIZE_REPORT_CODES } from '@api';

// 报告编码识别支持的图片格式
export const RECOGNIZABLE_IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'];
// 展示给用户看的格式文案（不含 PDF，识别功能不支持）
const RECOGNIZABLE_IMAGE_EXTS_TEXT = 'PNG、JPG、JPEG';

// 根据文件名/URL 判断是否为支持识别的图片格式
export function isRecognizableImage(name) {
  if (!name) {
    return false;
  }
  const clean = name.split('?')[0].split('#')[0];
  const dotIndex = clean.lastIndexOf('.');

  if (dotIndex < 0) {
    return false;
  }
  const ext = clean.slice(dotIndex + 1).toLowerCase();

  return RECOGNIZABLE_IMAGE_EXTS.includes(ext);
}

/**
 * 报告编码识别结果标签组
 * 传入商品证件的第一张图片地址，识别出可能的报告编码并以 Tag 平铺展示，点击可回填
 */
const ReportCodeTags = ({ imageUrl, value, onSelect }) => {
  // idle：未触发识别；loading：识别中；done：识别完成（codes 可能为空）
  const [status, setStatus] = useState('idle');
  const [codes, setCodes] = useState([]);
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!imageUrl) {
      requestIdRef.current += 1;
      setStatus('idle');
      setCodes([]);
      return;
    }

    requestIdRef.current += 1;
    const requestId = requestIdRef.current;

    setStatus('loading');
    setCodes([]);
    getData({
      api: API_POST_RECOGNIZE_REPORT_CODES,
      data: { imageUrl },
    })
      .then(res => {
        if (requestId !== requestIdRef.current) {
          return;
        }
        const list = res && res.data;

        setCodes(Array.isArray(list) ? list : []);
        setStatus('done');
      })
      .catch(() => {
        if (requestId !== requestIdRef.current) {
          return;
        }
        setCodes([]);
        setStatus('done');
      });
  }, [imageUrl]);

  return (
    <div style={{ fontSize: 12, color: '#999' }}>
      {status === 'idle' && (
        <span>
          上传商品证件后，将自动识别第一张图片上的报告编码；支持{RECOGNIZABLE_IMAGE_EXTS_TEXT}格式
        </span>
      )}
      {status === 'loading' && (
        <span>
          <Spin size="small" style={{ marginRight: 6 }} />
          正在识别商品证件中的报告编码，请稍候...
        </span>
      )}
      {status === 'done' && codes.length > 0 && (
        <div>
          <div style={{ marginBottom: 6 }}>
            系统从商品证件中识别到以下报告编码，点击可自动填入：
          </div>
          <div>
            {codes.map(code => (
              <Tag
                key={code}
                color={code === value ? 'blue' : undefined}
                style={{ cursor: 'pointer', marginBottom: 6 }}
                onClick={() => onSelect && onSelect(code)}>
                {code}
              </Tag>
            ))}
          </div>
        </div>
      )}
      {status === 'done' && codes.length === 0 && (
        <span>未从商品证件中识别到报告编码，请手动输入</span>
      )}
    </div>
  );
};

export default ReportCodeTags;
